<template>
  <div>
    <c-search-box ref="searchbox" @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-process
            label="LBLPROCESS"
            name="processCd"
            v-model="searchParam.processCd"
            @input="getList"
          />
        </div>
      </template>
    </c-search-box>
    <!-- 자재 목록 -->
    <c-table
      ref="materialTable"
      title="LBL0001709"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      :selection="popupParam.type"
      :columnSetting="false"
      :isExcelDown="false"
      :isFullScreen="false"
      rowKey="chemMaterialProcessId"
      @rowDblclick="rowDblclick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <!-- <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" /> -->
          <c-btn
            v-if="editable"
            label="LBLSELECT"
            icon="check"
            @btnClicked="select"
          />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "chem-material-process-pop",
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        type: "single",
        plantCd: "",
        processCd: "",
      }),
    },
    contentHeight: {
      type: [String, Number],
      default: function () {
        return "auto";
      },
    },
  },
  data() {
    return {
      searchParam: {
        processCd: "",
      },
      grid: {
        columns: [
          {
            name: "processName",
            field: "processName",
            label: "LBLPROCESS",
            align: "left",
            style: "width:120px",
            sortable: false,
          },
          {
            name: "materialName",
            field: "materialName",
            // 화학자재
            label: "LBL0000509",
            align: "left",
            style: "width:250px",
            sortable: false,
          },
          {
            name: "useFlag",
            field: "useFlag",
            // 제조 또는 사용여부
            label: "LBL0001115",
            align: "center",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "usePurpose",
            field: "usePurpose",
            // 사용용도
            label: "LBL0001712",
            align: "left",
            sortable: false,
          },
          {
            name: "dailyVolume",
            field: "dailyVolume",
            // 사용용도
            label: "LBL0001711",
            align: "right",
            style: "width:100px",
            sortable: false,
            type: "cost",
          },
          {
            name: "volumeUnitName",
            field: "volumeUnitName",
            // 취급량 단위
            label: "LBL0001710",
            align: "center",
            style: "width:100px",
            sortable: false,
          },
        ],
        data: [],
        height: "500px",
      },
      editable: true,
      listUrl: "",
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  watch: {
    contentHeight() {
      let height =
        this.contentHeight - this.$refs["searchbox"].$el.offsetHeight - 100;
      if (height < 400) {
        height = 500;
      }
      this.grid.height = height + "px";
    },
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.mdm.mam.chem.byprocess.url;

      if (this.popupParam.processCd) {
        this.searchParam.processCd = this.popupParam.processCd;
      }
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    select() {
      let selectData = this.$refs["materialTable"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          message: "MSGNOITEMS", // 선택된 항목이 없습니다.
          type: "warning", // success / info / warning / error
        });
      } else {
        this.$emit("closePopup", selectData);
      }
    },
    rowDblclick(row) {
      if (this.popupParam.type === "single") {
        this.$emit("closePopup", [row]);
      }
    },
  },
};
</script>
